'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('claim-landing', {
    url: '/claim/',
    templateUrl: '/views/claim-landing.html',
    controller: 'ClaimLandingCtrl',
    data: {
      hideNavigation: true,
      showSearchFooter: true,
    },
    resolve: {
      clinic: function() {
        return null;
      },
      pageTitle: function($pageTitle) {
        $pageTitle.set('Claim Clinic - Opencare');
      },
    },
  });

  $stateProvider.state('claim-landing-long-tail', {
    url: '/claim/:clinicId/',
    templateUrl: '/views/claim-landing.html',
    controller: 'ClaimLandingCtrl',
    data: {
      hideNavigation: true,
      showSearchFooter: true,
    },
    resolve: {
      clinic: function($stateParams, ClinicService) {
        return ClinicService.getClinic($stateParams.clinicId);
      },
      pageTitle: function($pageTitle, clinic) {
        $pageTitle.set('Claim - ' + clinic.name + ' - Opencare');
      },
    },
  });
});

angular.module('ClinicApp').controller('ClaimLandingCtrl', function(
  $scope,
  $q,
  $state,
  ClinicService,
  OCDomUtil,
  OCModalUtil,
  PhoneUtils,
) {
  $scope.step = 'SEARCH';
  $scope.phone = {
    number: '',
  };

  OCDomUtil.setFocusOn('input-phone');

  $scope.lookup = function() {
    $scope.phone.hasError = false;

    var formattedPhone = PhoneUtils.formatPhoneNumber($scope.phone.number);
    if (!formattedPhone || formattedPhone.length != 12) {
      $scope.phone.hasError = true;
      return $q.reject();
    }

    return ClinicService.findWithPhone(formattedPhone).then(function(values) {
      if (values.length) {
        for (var i = 0; i < values.length; i++) {
          var clinic = values[i];
          if (clinic.claimedAt) {
            continue;
          }
          $scope.clinic = clinic;
          return $scope.next();
        }
        OCModalUtil.showCustomModal({
          controller: 'ModalGenericSaveClose',
          templateUrl: '/views/modals/_claim-not-found.html',
        }).then(() => $scope.phone.number = null); // Reset the phone number, as the action is 'Try a different number');
      } else {
        OCModalUtil.showCustomModel({
          controller: 'ModalGenericSaveClose',
          templateUrl: '/views/modals/_claim-not-found.html',
        }).then(() => $state.go('signup'));
      }
    });
  };

  $scope.next = function() {
    if (!$scope.clinic) {
      return;
    }
    $state.go('claim-verify', {
      clinicId: $scope.clinic.id,
    });
  };

});
